// extracted by mini-css-extract-plugin
module.exports = {"header":"ProductListHeader_header__Vs6QZ","hasNavigation":"ProductListHeader_hasNavigation__kd3VI","title":"ProductListHeader_title__pnXe4"};